import I18n from 'I18n';
import UISection from 'UIComponents/section/UISection';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIImage from 'UIComponents/image/UIImage';
import UIButton from 'UIComponents/button/UIButton';
import CodeEntryForm from '../CodeEntryForm';
import LostDeviceTile from './LostDeviceTile';
import Image from '../../images/imageUrls';
import TestIds from '../../constants/testIDs';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HubspotAuthForm = ({
  formOnSubmit,
  codeLength,
  formOnChange,
  code,
  canSubmit,
  openTwoFactorRecovery
}) => {
  return /*#__PURE__*/_jsxs(UISection, {
    children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "reAuth.mobileAuth.explanation"
    }), /*#__PURE__*/_jsxs(UIFlex, {
      direction: "row",
      wrap: "wrap",
      align: "end",
      justify: "between",
      children: [/*#__PURE__*/_jsx(View, {
        inlineSize: "300px",
        children: /*#__PURE__*/_jsx(UIImage, {
          className: "m-y-5",
          src: Image.hubspotMobileApp,
          alt: I18n.text('reAuth.mobileAuth.imageAlt')
        })
      }), /*#__PURE__*/_jsx(View, {
        marginBlockEnd: "700",
        as: "div",
        children: /*#__PURE__*/_jsxs("form", {
          onSubmit: formOnSubmit,
          children: [/*#__PURE__*/_jsx(CodeEntryForm, {
            codeLength: codeLength,
            onChange: formOnChange,
            code: code
          }), /*#__PURE__*/_jsx(UIButton, {
            use: "primary",
            disabled: !canSubmit,
            type: "submit",
            "data-test-id": TestIds.CODE_SUBMIT_BUTTON,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "reAuth.codeForm.verify"
            })
          })]
        })
      })]
    }), /*#__PURE__*/_jsx(LostDeviceTile, {
      openTwoFactorRecovery: openTwoFactorRecovery
    })]
  });
};
export default HubspotAuthForm;